import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getModuleSettings, updateModuleSettings } from '../services/moduleSettingsService';
import { normalizeWarehouseIds } from '../utils/receptionConsumeAutomation';

const ModuleSettingsContext = createContext(null);

export function ModuleSettingsProvider({ children }) {
  const [machineryEnabled, setMachineryEnabledState] = useState(true);
  const [produccionEnabled, setProduccionEnabledState] = useState(false);
  const [produccionConcesionariaEnabled, setProduccionConcesionariaEnabledState] = useState(false);
  const [concesionariaVentaOperacionesEnabled, setConcesionariaVentaOperacionesEnabledState] = useState(false);
  const [produccionConcesionariaPlaneamientoEnabled, setProduccionConcesionariaPlaneamientoEnabledState] =
    useState(false);
  const [concesionariaOperacionesAlmacenEnabled, setConcesionariaOperacionesAlmacenEnabledState] = useState(false);
  const [concesionariaRecetasEnabled, setConcesionariaRecetasEnabledState] = useState(false);
  const [produccionFabricarPepDesdePtEnabled, setProduccionFabricarPepDesdePtEnabledState] = useState(false);
  const [produccionLineasEnabled, setProduccionLineasEnabledState] = useState(false);
  const [restaurantesEnabled, setRestaurantesEnabledState] = useState(true);
  const [activosEnabled, setActivosEnabledState] = useState(false);
  const [ventasEnabled, setVentasEnabledState] = useState(false);
  const [ventasCashLiquidationEnabled, setVentasCashLiquidationEnabledState] = useState(false);
  const [guidesRemoveStockRestrictions, setGuidesRemoveStockRestrictionsState] = useState(false);
  const [exitReferenceLastPurchaseCostEnabled, setExitReferenceLastPurchaseCostEnabledState] = useState(false);
  const [productConversionsEnabled, setProductConversionsEnabledState] = useState(false);
  const [quickProductLineEnabled, setQuickProductLineEnabledState] = useState(true);
  const [receptionConsumeButtonEnabled, setReceptionConsumeButtonEnabledState] = useState(false);
  const [receptionConsumeWarehouseIds, setReceptionConsumeWarehouseIdsState] = useState([]);
  const [receptionConsumeSingleProjectEnabled, setReceptionConsumeSingleProjectEnabledState] = useState(false);
  const [productsProjectEnabled, setProductsProjectEnabledState] = useState(false);
  const [productsIgvEnabled, setProductsIgvEnabledState] = useState(false);
  const [servicesClassificationEnabled, setServicesClassificationEnabledState] = useState(false);
  const [adjustmentMassiveItemThreshold, setAdjustmentMassiveItemThresholdState] = useState(100);
  const [kardexAuditModuleEnabled, setKardexAuditModuleEnabledState] = useState(false);
  const [kardexTemporaryCostEnabled, setKardexTemporaryCostEnabledState] = useState(true);
  const [comprasPurchaseSitesEnabled, setComprasPurchaseSitesEnabledState] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const applySettingsFromApi = useCallback((d) => {
    if (typeof d.machinery_enabled === 'boolean') setMachineryEnabledState(d.machinery_enabled);
    if (typeof d.produccion_enabled === 'boolean') setProduccionEnabledState(d.produccion_enabled);
    if (typeof d.produccion_concesionaria_enabled === 'boolean') {
      setProduccionConcesionariaEnabledState(d.produccion_concesionaria_enabled);
    }
    if (typeof d.concesionaria_venta_operaciones_enabled === 'boolean') {
      setConcesionariaVentaOperacionesEnabledState(d.concesionaria_venta_operaciones_enabled);
    }
    if (typeof d.produccion_concesionaria_planeamiento_enabled === 'boolean') {
      setProduccionConcesionariaPlaneamientoEnabledState(d.produccion_concesionaria_planeamiento_enabled);
    }
    if (typeof d.concesionaria_operaciones_almacen_enabled === 'boolean') {
      setConcesionariaOperacionesAlmacenEnabledState(d.concesionaria_operaciones_almacen_enabled);
    }
    if (typeof d.concesionaria_recetas_enabled === 'boolean') {
      setConcesionariaRecetasEnabledState(d.concesionaria_recetas_enabled);
    }
    if (typeof d.produccion_fabricar_pep_desde_pt_enabled === 'boolean') {
      setProduccionFabricarPepDesdePtEnabledState(d.produccion_fabricar_pep_desde_pt_enabled);
    }
    if (typeof d.produccion_lineas_enabled === 'boolean') {
      setProduccionLineasEnabledState(d.produccion_lineas_enabled);
    }
    if (typeof d.restaurantes_enabled === 'boolean') setRestaurantesEnabledState(d.restaurantes_enabled);
    if (typeof d.activos_enabled === 'boolean') setActivosEnabledState(d.activos_enabled);
    if (typeof d.ventas_enabled === 'boolean') setVentasEnabledState(d.ventas_enabled);
    if (typeof d.ventas_cash_liquidation_enabled === 'boolean') {
      setVentasCashLiquidationEnabledState(d.ventas_cash_liquidation_enabled);
    }
    if (typeof d.guides_remove_stock_restrictions === 'boolean') {
      setGuidesRemoveStockRestrictionsState(d.guides_remove_stock_restrictions);
    }
    if (typeof d.exit_reference_last_purchase_cost_enabled === 'boolean') {
      setExitReferenceLastPurchaseCostEnabledState(d.exit_reference_last_purchase_cost_enabled);
    }
    if (typeof d.product_conversions_enabled === 'boolean') {
      setProductConversionsEnabledState(d.product_conversions_enabled);
    }
    if (typeof d.quick_product_line_enabled === 'boolean') {
      setQuickProductLineEnabledState(d.quick_product_line_enabled);
    }
    if (typeof d.reception_consume_button_enabled === 'boolean') {
      setReceptionConsumeButtonEnabledState(d.reception_consume_button_enabled);
    }
    if (Array.isArray(d.reception_consume_warehouse_ids)) {
      setReceptionConsumeWarehouseIdsState(normalizeWarehouseIds(d.reception_consume_warehouse_ids));
    }
    if (typeof d.reception_consume_single_project_enabled === 'boolean') {
      setReceptionConsumeSingleProjectEnabledState(d.reception_consume_single_project_enabled);
    }
    if (typeof d.products_project_enabled === 'boolean') {
      setProductsProjectEnabledState(d.products_project_enabled);
    }
    if (typeof d.products_igv_enabled === 'boolean') {
      setProductsIgvEnabledState(d.products_igv_enabled);
    }
    if (typeof d.services_classification_enabled === 'boolean') {
      setServicesClassificationEnabledState(d.services_classification_enabled);
    }
    if (d.adjustment_massive_item_threshold != null) {
      const n = Number(d.adjustment_massive_item_threshold);
      if (Number.isFinite(n) && n > 0) {
        setAdjustmentMassiveItemThresholdState(n);
      }
    }
    if (typeof d.kardex_audit_module_enabled === 'boolean') {
      setKardexAuditModuleEnabledState(d.kardex_audit_module_enabled);
    }
    if (typeof d.kardex_temporary_cost_enabled === 'boolean') {
      setKardexTemporaryCostEnabledState(d.kardex_temporary_cost_enabled);
    }
    if (typeof d.compras_purchase_sites_enabled === 'boolean') {
      setComprasPurchaseSitesEnabledState(d.compras_purchase_sites_enabled);
    }
  }, []);

  useEffect(() => {
    let cancelled = false;
    getModuleSettings()
      .then((res) => {
        if (cancelled) return;
        if (res.success && res.data) {
          applySettingsFromApi(res.data);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setMachineryEnabledState(true);
          setProduccionEnabledState(false);
          setProduccionConcesionariaEnabledState(false);
          setProduccionFabricarPepDesdePtEnabledState(false);
          setRestaurantesEnabledState(true);
          setActivosEnabledState(false);
          setVentasEnabledState(false);
          setVentasCashLiquidationEnabledState(false);
          setGuidesRemoveStockRestrictionsState(false);
          setExitReferenceLastPurchaseCostEnabledState(false);
          setProductConversionsEnabledState(false);
          setQuickProductLineEnabledState(true);
          setReceptionConsumeButtonEnabledState(false);
          setReceptionConsumeWarehouseIdsState([]);
          setReceptionConsumeSingleProjectEnabledState(false);
          setProductsProjectEnabledState(false);
          setProductsIgvEnabledState(false);
          setServicesClassificationEnabledState(false);
        }
      })
      .finally(() => {
        if (!cancelled) setLoaded(true);
      });
    return () => {
      cancelled = true;
    };
  }, [applySettingsFromApi]);

  const setMachineryEnabled = (value) => {
    const newValue = Boolean(value);
    setMachineryEnabledState(newValue);
    return updateModuleSettings({ machinery_enabled: newValue })
      .then((res) => {
        if (res.success && res.data) applySettingsFromApi(res.data);
        return res;
      })
      .catch(() => {
        setMachineryEnabledState((prev) => prev);
        throw new Error('No se pudo guardar la configuración');
      });
  };

  const setProduccionEnabled = (value) => {
    const newValue = Boolean(value);
    setProduccionEnabledState(newValue);
    return updateModuleSettings({ produccion_enabled: newValue })
      .then((res) => {
        if (res.success && res.data) applySettingsFromApi(res.data);
        return res;
      })
      .catch(() => {
        setProduccionEnabledState((prev) => prev);
        throw new Error('No se pudo guardar la configuración');
      });
  };

  const setProduccionConcesionariaEnabled = (value) => {
    const newValue = Boolean(value);
    setProduccionConcesionariaEnabledState(newValue);
    return updateModuleSettings({ produccion_concesionaria_enabled: newValue })
      .then((res) => {
        if (res.success && res.data) applySettingsFromApi(res.data);
        return res;
      })
      .catch(() => {
        setProduccionConcesionariaEnabledState((prev) => prev);
        throw new Error('No se pudo guardar la configuración');
      });
  };

  const setConcesionariaVentaOperacionesEnabled = (value) => {
    const newValue = Boolean(value);
    setConcesionariaVentaOperacionesEnabledState(newValue);
    return updateModuleSettings({ concesionaria_venta_operaciones_enabled: newValue })
      .then((res) => {
        if (res.success && res.data) applySettingsFromApi(res.data);
        return res;
      })
      .catch(() => {
        setConcesionariaVentaOperacionesEnabledState((prev) => prev);
        throw new Error('No se pudo guardar la configuración');
      });
  };

  const setProduccionConcesionariaPlaneamientoEnabled = (value) => {
    const newValue = Boolean(value);
    setProduccionConcesionariaPlaneamientoEnabledState(newValue);
    return updateModuleSettings({ produccion_concesionaria_planeamiento_enabled: newValue })
      .then((res) => {
        if (res.success && res.data) applySettingsFromApi(res.data);
        return res;
      })
      .catch(() => {
        setProduccionConcesionariaPlaneamientoEnabledState((prev) => prev);
        throw new Error('No se pudo guardar la configuración');
      });
  };

  const setConcesionariaOperacionesAlmacenEnabled = (value) => {
    const newValue = Boolean(value);
    setConcesionariaOperacionesAlmacenEnabledState(newValue);
    return updateModuleSettings({ concesionaria_operaciones_almacen_enabled: newValue })
      .then((res) => {
        if (res.success && res.data) applySettingsFromApi(res.data);
        return res;
      })
      .catch(() => {
        setConcesionariaOperacionesAlmacenEnabledState((prev) => prev);
        throw new Error('No se pudo guardar la configuración');
      });
  };

  const setConcesionariaRecetasEnabled = (value) => {
    const newValue = Boolean(value);
    setConcesionariaRecetasEnabledState(newValue);
    return updateModuleSettings({ concesionaria_recetas_enabled: newValue })
      .then((res) => {
        if (res.success && res.data) applySettingsFromApi(res.data);
        return res;
      })
      .catch(() => {
        setConcesionariaRecetasEnabledState((prev) => prev);
        throw new Error('No se pudo guardar la configuración');
      });
  };

  const setProduccionFabricarPepDesdePtEnabled = (value) => {
    const newValue = Boolean(value);
    setProduccionFabricarPepDesdePtEnabledState(newValue);
    return updateModuleSettings({ produccion_fabricar_pep_desde_pt_enabled: newValue })
      .then((res) => {
        if (res.success && res.data) applySettingsFromApi(res.data);
        return res;
      })
      .catch(() => {
        setProduccionFabricarPepDesdePtEnabledState((prev) => prev);
        throw new Error('No se pudo guardar la configuración');
      });
  };

  const setProduccionLineasEnabled = (value) => {
    const newValue = Boolean(value);
    setProduccionLineasEnabledState(newValue);
    return updateModuleSettings({ produccion_lineas_enabled: newValue })
      .then((res) => {
        if (res.success && res.data) applySettingsFromApi(res.data);
        return res;
      })
      .catch(() => {
        setProduccionLineasEnabledState((prev) => prev);
        throw new Error('No se pudo guardar la configuración');
      });
  };

  const setRestaurantesEnabled = (value) => {
    const newValue = Boolean(value);
    setRestaurantesEnabledState(newValue);
    return updateModuleSettings({ restaurantes_enabled: newValue })
      .then((res) => {
        if (res.success && res.data) applySettingsFromApi(res.data);
        return res;
      })
      .catch(() => {
        setRestaurantesEnabledState((prev) => prev);
        throw new Error('No se pudo guardar la configuración');
      });
  };

  const setActivosEnabled = (value) => {
    const newValue = Boolean(value);
    setActivosEnabledState(newValue);
    return updateModuleSettings({ activos_enabled: newValue })
      .then((res) => {
        if (res.success && res.data) applySettingsFromApi(res.data);
        return res;
      })
      .catch(() => {
        setActivosEnabledState((prev) => prev);
        throw new Error('No se pudo guardar la configuración');
      });
  };

  const setVentasEnabled = (value) => {
    const newValue = Boolean(value);
    setVentasEnabledState(newValue);
    return updateModuleSettings({ ventas_enabled: newValue })
      .then((res) => {
        if (res.success && res.data) applySettingsFromApi(res.data);
        return res;
      })
      .catch(() => {
        setVentasEnabledState((prev) => prev);
        throw new Error('No se pudo guardar la configuración');
      });
  };

  const setVentasCashLiquidationEnabled = (value) => {
    const newValue = Boolean(value);
    setVentasCashLiquidationEnabledState(newValue);
    return updateModuleSettings({ ventas_cash_liquidation_enabled: newValue })
      .then((res) => {
        if (res.success && res.data) applySettingsFromApi(res.data);
        return res;
      })
      .catch(() => {
        setVentasCashLiquidationEnabledState((prev) => prev);
        throw new Error('No se pudo guardar la configuración');
      });
  };

  const setGuidesRemoveStockRestrictions = (value) => {
    const newValue = Boolean(value);
    setGuidesRemoveStockRestrictionsState(newValue);
    return updateModuleSettings({ guides_remove_stock_restrictions: newValue })
      .then((res) => {
        if (res.success && res.data) applySettingsFromApi(res.data);
        return res;
      })
      .catch(() => {
        setGuidesRemoveStockRestrictionsState((prev) => prev);
        throw new Error('No se pudo guardar la configuración');
      });
  };

  const setExitReferenceLastPurchaseCostEnabled = (value) => {
    const newValue = Boolean(value);
    setExitReferenceLastPurchaseCostEnabledState(newValue);
    return updateModuleSettings({ exit_reference_last_purchase_cost_enabled: newValue })
      .then((res) => {
        if (res.success && res.data) applySettingsFromApi(res.data);
        return res;
      })
      .catch(() => {
        setExitReferenceLastPurchaseCostEnabledState((prev) => prev);
        throw new Error('No se pudo guardar la configuración');
      });
  };

  const setProductConversionsEnabled = (value) => {
    const newValue = Boolean(value);
    setProductConversionsEnabledState(newValue);
    return updateModuleSettings({ product_conversions_enabled: newValue })
      .then((res) => {
        if (res.success && res.data) applySettingsFromApi(res.data);
        return res;
      })
      .catch(() => {
        setProductConversionsEnabledState((prev) => prev);
        throw new Error('No se pudo guardar la configuración');
      });
  };

  const setQuickProductLineEnabled = (value) => {
    const newValue = Boolean(value);
    setQuickProductLineEnabledState(newValue);
    return updateModuleSettings({ quick_product_line_enabled: newValue })
      .then((res) => {
        if (res.success && res.data) applySettingsFromApi(res.data);
        return res;
      })
      .catch(() => {
        setQuickProductLineEnabledState((prev) => prev);
        throw new Error('No se pudo guardar la configuración');
      });
  };

  const setReceptionConsumeButtonEnabled = (value) => {
    const newValue = Boolean(value);
    setReceptionConsumeButtonEnabledState(newValue);
    return updateModuleSettings({ reception_consume_button_enabled: newValue })
      .then((res) => {
        if (res.success && res.data) applySettingsFromApi(res.data);
        return res;
      })
      .catch(() => {
        setReceptionConsumeButtonEnabledState((prev) => prev);
        throw new Error('No se pudo guardar la configuración');
      });
  };

  const setReceptionConsumeWarehouseIds = (value) => {
    const newValue = normalizeWarehouseIds(value);
    setReceptionConsumeWarehouseIdsState(newValue);
    return updateModuleSettings({ reception_consume_warehouse_ids: newValue })
      .then((res) => {
        if (res.success && res.data) applySettingsFromApi(res.data);
        return res;
      })
      .catch(() => {
        setReceptionConsumeWarehouseIdsState((prev) => prev);
        throw new Error('No se pudo guardar la configuración');
      });
  };

  const setReceptionConsumeSingleProjectEnabled = (value) => {
    const newValue = Boolean(value);
    setReceptionConsumeSingleProjectEnabledState(newValue);
    return updateModuleSettings({ reception_consume_single_project_enabled: newValue })
      .then((res) => {
        if (res.success && res.data) applySettingsFromApi(res.data);
        return res;
      })
      .catch(() => {
        setReceptionConsumeSingleProjectEnabledState((prev) => prev);
        throw new Error('No se pudo guardar la configuración');
      });
  };

  const setProductsProjectEnabled = (value) => {
    const newValue = Boolean(value);
    setProductsProjectEnabledState(newValue);
    return updateModuleSettings({ products_project_enabled: newValue })
      .then((res) => {
        if (res.success && res.data) applySettingsFromApi(res.data);
        return res;
      })
      .catch(() => {
        setProductsProjectEnabledState((prev) => prev);
        throw new Error('No se pudo guardar la configuración');
      });
  };

  const setProductsIgvEnabled = (value) => {
    const newValue = Boolean(value);
    setProductsIgvEnabledState(newValue);
    return updateModuleSettings({ products_igv_enabled: newValue })
      .then((res) => {
        if (res.success && res.data) applySettingsFromApi(res.data);
        return res;
      })
      .catch(() => {
        setProductsIgvEnabledState((prev) => prev);
        throw new Error('No se pudo guardar la configuración');
      });
  };

  const setServicesClassificationEnabled = (value) => {
    const newValue = Boolean(value);
    setServicesClassificationEnabledState(newValue);
    return updateModuleSettings({ services_classification_enabled: newValue })
      .then((res) => {
        if (res.success && res.data) applySettingsFromApi(res.data);
        return res;
      })
      .catch(() => {
        setServicesClassificationEnabledState((prev) => prev);
        throw new Error('No se pudo guardar la configuración');
      });
  };

  const setKardexAuditModuleEnabled = (value) => {
    const newValue = Boolean(value);
    setKardexAuditModuleEnabledState(newValue);
    return updateModuleSettings({ kardex_audit_module_enabled: newValue })
      .then((res) => {
        if (res.success && res.data) applySettingsFromApi(res.data);
        return res;
      })
      .catch(() => {
        setKardexAuditModuleEnabledState((prev) => prev);
        throw new Error('No se pudo guardar la configuración');
      });
  };

  const setKardexTemporaryCostEnabled = (value) => {
    const newValue = Boolean(value);
    setKardexTemporaryCostEnabledState(newValue);
    return updateModuleSettings({ kardex_temporary_cost_enabled: newValue })
      .then((res) => {
        if (res.success && res.data) applySettingsFromApi(res.data);
        return res;
      })
      .catch(() => {
        setKardexTemporaryCostEnabledState((prev) => prev);
        throw new Error('No se pudo guardar la configuración');
      });
  };

  const setComprasPurchaseSitesEnabled = (value) => {
    const newValue = Boolean(value);
    setComprasPurchaseSitesEnabledState(newValue);
    return updateModuleSettings({ compras_purchase_sites_enabled: newValue })
      .then((res) => {
        if (res.success && res.data) applySettingsFromApi(res.data);
        return res;
      })
      .catch(() => {
        setComprasPurchaseSitesEnabledState((prev) => prev);
        throw new Error('No se pudo guardar la configuración');
      });
  };

  return (
    <ModuleSettingsContext.Provider
      value={{
        machineryEnabled,
        produccionEnabled,
        produccionConcesionariaEnabled,
        concesionariaVentaOperacionesEnabled,
        produccionConcesionariaPlaneamientoEnabled,
        concesionariaOperacionesAlmacenEnabled,
        concesionariaRecetasEnabled,
        produccionFabricarPepDesdePtEnabled,
        produccionLineasEnabled,
        restaurantesEnabled,
        activosEnabled,
        ventasEnabled,
        ventasCashLiquidationEnabled,
        guidesRemoveStockRestrictions,
        exitReferenceLastPurchaseCostEnabled,
        productConversionsEnabled,
        setProductConversionsEnabled,
        quickProductLineEnabled,
        setQuickProductLineEnabled,
        receptionConsumeButtonEnabled,
        setReceptionConsumeButtonEnabled,
        receptionConsumeWarehouseIds,
        setReceptionConsumeWarehouseIds,
        receptionConsumeSingleProjectEnabled,
        setReceptionConsumeSingleProjectEnabled,
        productsProjectEnabled,
        setProductsProjectEnabled,
        productsIgvEnabled,
        setProductsIgvEnabled,
        servicesClassificationEnabled,
        setServicesClassificationEnabled,
        adjustmentMassiveItemThreshold,
        kardexAuditModuleEnabled,
        setKardexAuditModuleEnabled,
        kardexTemporaryCostEnabled,
        setKardexTemporaryCostEnabled,
        comprasPurchaseSitesEnabled,
        setComprasPurchaseSitesEnabled,
        setMachineryEnabled,
        setProduccionEnabled,
        setProduccionConcesionariaEnabled,
        setConcesionariaVentaOperacionesEnabled,
        setProduccionConcesionariaPlaneamientoEnabled,
        setConcesionariaOperacionesAlmacenEnabled,
        setConcesionariaRecetasEnabled,
        setProduccionFabricarPepDesdePtEnabled,
        setProduccionLineasEnabled,
        setRestaurantesEnabled,
        setActivosEnabled,
        setVentasEnabled,
        setVentasCashLiquidationEnabled,
        setGuidesRemoveStockRestrictions,
        setExitReferenceLastPurchaseCostEnabled,
        loaded,
      }}
    >
      {children}
    </ModuleSettingsContext.Provider>
  );
}

export function useModuleSettings() {
  const ctx = useContext(ModuleSettingsContext);
  if (!ctx) {
    throw new Error('useModuleSettings must be used within ModuleSettingsProvider');
  }
  return ctx;
}

export default ModuleSettingsContext;
